// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"873dab1e","239":"2d52f799","453":"8195fb78","455":"ce94c2a2"}[chunkId] + ".chunk.js";
};